/**
 * CoandaView Landing Page Authentication
 * Handles login and signup forms
 */

const API_BASE = window.location.origin.includes('localhost')
  ? 'http://localhost:8082'
  : '';

async function showAuthModal(mode) {
  const modal = document.getElementById('authModal');
  const loginForm = document.getElementById('loginForm');
  const signupForm = document.getElementById('signupForm');
  const waitlistForm = document.getElementById('waitlistForm');
  const signupSuccess = document.getElementById('signupSuccess');

  // Hide all forms first
  loginForm.style.display = 'none';
  signupForm.style.display = 'none';
  if (waitlistForm) waitlistForm.style.display = 'none';
  if (signupSuccess) signupSuccess.style.display = 'none';

  // Show the requested form
  if (mode === 'login') {
    loginForm.style.display = 'block';
    document.getElementById('loginError').style.display = 'none';
  } else if (mode === 'waitlist') {
    // Directly show waitlist form
    if (waitlistForm) {
      waitlistForm.style.display = 'block';
      document.getElementById('waitlistError').style.display = 'none';
      document.getElementById('waitlistSuccess').style.display = 'none';
    }
  } else {
    // Check if registration is limited before showing signup
    try {
      const response = await fetch(`${API_BASE}/api/waitlist/check-limit`);
      const result = await response.json();

      if (result.status === 'success' && result.data.show_waitlist) {
        // Registration is limited, show waitlist form
        if (waitlistForm) {
          waitlistForm.style.display = 'block';
          document.getElementById('waitlistError').style.display = 'none';
          document.getElementById('waitlistSuccess').style.display = 'none';
        } else {
          // Fallback to signup form if waitlist form doesn't exist
          signupForm.style.display = 'block';
          document.getElementById('signupError').style.display = 'none';
        }
      } else {
        // Registration is open, show signup form
        signupForm.style.display = 'block';
        document.getElementById('signupError').style.display = 'none';
      }
    } catch (error) {
      // On error, default to showing signup form
      console.error('Error checking registration limit:', error);
      signupForm.style.display = 'block';
      document.getElementById('signupError').style.display = 'none';
    }
  }

  // Show modal
  modal.style.display = 'flex';
}

function closeAuthModal() {
  const modal = document.getElementById('authModal');
  const signupSuccess = document.getElementById('signupSuccess');
  const waitlistForm = document.getElementById('waitlistForm');

  // Hide the success message if it exists
  if (signupSuccess) {
    signupSuccess.style.display = 'none';
  }

  // Hide waitlist form if it exists
  if (waitlistForm) {
    waitlistForm.style.display = 'none';
  }

  modal.style.display = 'none';
}

/**
 * Handle waitlist form submission
 */
async function handleWaitlistJoin(event) {
  event.preventDefault();

  const name = document.getElementById('waitlistName').value.trim();
  const email = document.getElementById('waitlistEmail').value.trim();
  const errorDiv = document.getElementById('waitlistError');
  const successDiv = document.getElementById('waitlistSuccess');

  // Reset messages
  errorDiv.style.display = 'none';
  successDiv.style.display = 'none';

  if (!email) {
    errorDiv.textContent = 'Please enter your email address';
    errorDiv.style.display = 'block';
    return;
  }

  try {
    const response = await fetch(`${API_BASE}/api/waitlist/join`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: email,
        name: name || null,
        source: 'registration_limit'
      }),
    });

    const result = await response.json();

    if (result.status === 'success') {
      // Hide the form and show success
      document.querySelector('#waitlistForm form').style.display = 'none';
      successDiv.innerHTML = `
        <div style="margin-bottom: 12px;">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#30D158" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
        </div>
        <h3 style="margin: 0 0 12px 0; color: #30D158;">You're on the list!</h3>
        <p style="margin: 0; color: rgba(255,255,255,0.8);">${result.message}</p>
      `;
      successDiv.style.display = 'block';
    } else {
      errorDiv.textContent = result.message || 'Failed to join waitlist';
      errorDiv.style.display = 'block';
    }
  } catch (error) {
    console.error('Error joining waitlist:', error);
    errorDiv.textContent = 'An error occurred. Please try again.';
    errorDiv.style.display = 'block';
  }
}

// Close modal on background click
document.addEventListener('click', (e) => {
  const modal = document.getElementById('authModal');
  if (e.target === modal) {
    closeAuthModal();
  }
});

// Handle Login
async function handleLogin(event) {
  event.preventDefault();

  const email = document.getElementById('loginEmail').value;
  const password = document.getElementById('loginPassword').value;
  const errorDiv = document.getElementById('loginError');

  try {
    const response = await fetch(`${API_BASE}/api/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    });

    const contentType = response.headers.get('content-type') || '';
    const rawText = await response.text();
    let result = null;

    if (contentType.includes('application/json')) {
      try {
        result = JSON.parse(rawText);
      } catch (parseError) {
        console.error('Failed to parse login JSON response:', parseError, rawText);
      }
    }

    if (!result) {
      const message = (rawText && rawText.trim()) || response.statusText || 'Unexpected response from server.';
      throw new Error(`Login failed: ${message}`);
    }

    if (result.status === 'success') {
      // Store token and user info
      localStorage.setItem('coandacloud_token', result.data.token);
      localStorage.setItem('coandacloud_user', JSON.stringify(result.data.user));

      // Track login event
      if (window.Analytics) {
        window.Analytics.trackLogin('email');
      }

      // Redirect to main app
      window.location.href = '/dashboard.html';
    } else {
      // Show error
      errorDiv.textContent = result.message || 'Login failed';
      errorDiv.style.display = 'block';

      // If verification required, show resend option
      if (result.data?.verification_required && result.data?.email) {
        errorDiv.innerHTML = `
          ${result.message}
          <br><br>
          <a href="#" onclick="resendVerification('${result.data.email}'); return false;"
             style="color: #007AFF; text-decoration: none; font-weight: 600;">
            Resend verification email
          </a>
        `;
      }
    }
  } catch (error) {
    console.error('Login error:', error);
    errorDiv.textContent = error.message || 'An error occurred. Please try again.';
    errorDiv.style.display = 'block';
  }
}

// Handle Signup
async function handleSignup(event) {
  event.preventDefault();

  const name = document.getElementById('signupName').value;
  const email = document.getElementById('signupEmail').value;
  const password = document.getElementById('signupPassword').value;
  const tosAccepted = document.getElementById('tosAcceptance').checked;
  const errorDiv = document.getElementById('signupError');

  // Validate ToS acceptance
  if (!tosAccepted) {
    errorDiv.textContent = 'You must accept the Terms of Service to create an account';
    errorDiv.style.display = 'block';
    return;
  }

  try {
    // Get current ToS version
    const versionResponse = await fetch(`${API_BASE}/api/tos/current-version`);
    const versionData = await versionResponse.json();
    const tosVersion = versionData.data?.version || '1.0';

    const response = await fetch(`${API_BASE}/api/auth/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name,
        email,
        password,
        tos_accepted: tosAccepted,
        tos_version: tosVersion
      }),
    });

    const contentType = response.headers.get('content-type') || '';
    const rawText = await response.text();
    let result = null;

    if (contentType.includes('application/json')) {
      try {
        result = JSON.parse(rawText);
      } catch (parseError) {
        console.error('Failed to parse signup JSON response:', parseError, rawText);
      }
    }

    if (!result) {
      const message = (rawText && rawText.trim()) || response.statusText || 'Unexpected response from server.';
      throw new Error(`Registration failed: ${message}`);
    }

    if (result.status === 'success') {
      // Track signup event
      if (window.Analytics) {
        window.Analytics.trackSignup('email');
      }

      // NEW BEHAVIOR: Show verification message instead of logging in
      errorDiv.style.display = 'none';

      // FORCIBLY hide signup form and error div
      signupForm.style.setProperty('display', 'none', 'important');
      errorDiv.style.setProperty('display', 'none', 'important');

      // Create and show success message
      const modalContent = document.querySelector('#authModal .modal-content');
      let successDiv = document.getElementById('signupSuccess');

      if (!successDiv) {
        // Create success message div
        successDiv = document.createElement('div');
        successDiv.id = 'signupSuccess';
        modalContent.appendChild(successDiv);
      }

      // Clear any existing content and set new content
      successDiv.innerHTML = `
        <div style="font-size: 60px; color: #30D158; margin: 0 0 15px 0; animation: scaleIn 0.5s ease-out;">✓</div>
        <h2 style="color: #FFFFFF; margin: 0 0 12px 0; font-size: 26px; font-weight: 700;">Registration Successful!</h2>
        <p style="color: rgba(255, 255, 255, 0.8); line-height: 1.6; margin: 0 0 8px 0; font-size: 15px;">
          We've sent a verification email to<br>
          <strong style="color: #007AFF; font-size: 16px;">${email}</strong>
        </p>
        <p style="color: rgba(255, 255, 255, 0.8); line-height: 1.6; margin: 0 0 20px 0; font-size: 15px;">
          Please check your inbox and click the verification link to activate your account.
        </p>
        <div style="background: rgba(255, 255, 255, 0.05); padding: 16px; border-radius: 8px; margin-bottom: 20px; border: 1px solid rgba(255, 255, 255, 0.1);">
          <p style="color: rgba(255, 255, 255, 0.6); font-size: 13px; margin: 0 0 10px 0;">
            Didn't receive the email?
          </p>
          <a href="#" onclick="resendVerification('${email}'); return false;"
             style="color: #007AFF; text-decoration: none; font-weight: 700; font-size: 14px; display: inline-block; padding: 8px 18px; background: rgba(0, 122, 255, 0.1); border-radius: 6px; border: 2px solid #007AFF; transition: all 0.2s;"
             onmouseover="this.style.background='rgba(0, 122, 255, 0.2)'"
             onmouseout="this.style.background='rgba(0, 122, 255, 0.1)'">
            Resend Verification Email
          </a>
        </div>
        <button onclick="closeAuthModal();"
                style="padding: 12px 36px; background: linear-gradient(135deg, #007AFF 0%, #30D158 100%);
                       color: white; border: none; border-radius: 6px; cursor: pointer;
                       font-size: 16px; font-weight: 700; box-shadow: 0 4px 12px rgba(0, 122, 255, 0.4);
                       transition: transform 0.2s; min-width: 100px;"
                onmouseover="this.style.transform='scale(1.05)'"
                onmouseout="this.style.transform='scale(1)'">
          OK
        </button>
      `;

      // Force display and styling with dark background and compact padding
      successDiv.style.cssText = 'display: block !important; padding: 0; text-align: center; opacity: 1; visibility: visible; background: transparent; margin: 0; max-height: none; overflow: visible;';

      // Scroll to top of modal to ensure message is visible
      modalContent.scrollTop = 0;

    } else {
      // Show error
      errorDiv.textContent = result.message || 'Registration failed';
      errorDiv.style.display = 'block';

      // If user already exists but unverified, show resend option
      if (result.data?.verification_required) {
        errorDiv.innerHTML = `
          ${result.message}
          <br><br>
          <a href="#" onclick="resendVerification('${email}'); return false;"
             style="color: #007AFF; text-decoration: none; font-weight: 600;">
            Resend verification email
          </a>
        `;
      }
    }
  } catch (error) {
    console.error('Signup error:', error);
    errorDiv.textContent = error.message || 'An error occurred. Please try again.';
    errorDiv.style.display = 'block';
  }
}

// Resend verification email
async function resendVerification(email) {
  try {
    const response = await fetch(`${API_BASE}/api/auth/resend-verification`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    const result = await response.json();

    if (result.status === 'success') {
      alert('Verification email sent! Please check your inbox.');
    } else {
      alert(result.message || 'Failed to send verification email. Please try again.');
    }
  } catch (error) {
    console.error('Resend verification error:', error);
    alert('An error occurred. Please try again.');
  }
}

// Auto-redirect removed - let users visit landing page even when logged in
// Landing page now shows "Dashboard" button for authenticated users
// (function checkAuth() {
//   const token = localStorage.getItem('coandacloud_token');
//   if (token) {
//     window.location.href = '/dashboard.html';
//   }
// })();

// Check if account was deleted and show message
(function checkAccountDeleted() {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('deleted') === 'true') {
    // Create and show success message
    const messageDiv = document.createElement('div');
    messageDiv.style.cssText = `
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: linear-gradient(135deg, #10b981 0%, #059669 100%);
      color: white;
      padding: 16px 32px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
      z-index: 10000;
      font-weight: 600;
      font-size: 16px;
      text-align: center;
    `;
    messageDiv.textContent = 'Your account has been permanently deleted';
    document.body.appendChild(messageDiv);

    // Remove message after 5 seconds
    setTimeout(() => {
      messageDiv.style.opacity = '0';
      messageDiv.style.transition = 'opacity 0.5s';
      setTimeout(() => messageDiv.remove(), 500);
    }, 5000);

    // Clean up URL
    window.history.replaceState({}, document.title, window.location.pathname);
  }
})();

// ============================================================================
// Terms of Service Modal Functions
// NOTE: ToS modal functions (showTosModal, closeTosModal, loadTosContent)
// are now in shared tos-modal.js file
// ============================================================================

// ============================================================================
// ToS Update Modal (for existing users)
// ============================================================================

async function checkTosStatus() {
  const token = localStorage.getItem('coandacloud_token');
  if (!token) return;

  try {
    const response = await fetch(`${API_BASE}/api/tos/status`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    const result = await response.json();
    if (result.status === 'success' && result.data.needs_acceptance) {
      showTosUpdateModal();
    }
  } catch (error) {
    console.error('Failed to check ToS status:', error);
  }
}

function showTosUpdateModal() {
  const modal = document.getElementById('tosUpdateModal');
  modal.style.display = 'flex';
}

function closeTosUpdateModal() {
  const modal = document.getElementById('tosUpdateModal');
  modal.style.display = 'none';
}

async function acceptTosUpdate() {
  const checkbox = document.getElementById('tosUpdateAcceptance');
  const errorDiv = document.getElementById('tosUpdateError');
  const button = document.getElementById('btnAcceptTosUpdate');

  if (!checkbox.checked) {
    errorDiv.textContent = 'You must accept the updated terms to continue';
    errorDiv.style.display = 'block';
    return;
  }

  button.disabled = true;
  button.textContent = 'Accepting...';

  try {
    const token = localStorage.getItem('coandacloud_token');
    const response = await fetch(`${API_BASE}/api/tos/accept`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({})
    });

    const result = await response.json();
    if (result.status === 'success') {
      closeTosUpdateModal();
      // Reload page to reflect new ToS status
      window.location.reload();
    } else {
      errorDiv.textContent = result.message || 'Failed to accept terms';
      errorDiv.style.display = 'block';
    }
  } catch (error) {
    console.error('Failed to accept ToS:', error);
    errorDiv.textContent = 'An error occurred. Please try again.';
    errorDiv.style.display = 'block';
  } finally {
    button.disabled = false;
    button.textContent = 'Accept & Continue';
  }
}
